import React, { useEffect, useRef } from "react";
import { motion } from "framer-motion";

/*
 * SplitTextReveal — word-by-word reveal with a brand-color sweep over each word.
 * Keeps text fully readable; only animates entrance.
 */
export default function SplitTextReveal({
  text,
  className = "",
  highlight = false,
  delay = 0,
  staggerChildren = 0.05,
}) {
  const words = text.split(" ");
  return (
    <motion.span
      initial="hidden"
      animate="show"
      variants={{
        hidden: {},
        show: { transition: { staggerChildren, delayChildren: delay } },
      }}
      className={`inline-block ${className}`}
      aria-label={text}
    >
      {words.map((w, i) => (
        <span key={i} className="inline-block overflow-hidden align-bottom mr-[0.25em] last:mr-0">
          <motion.span
            variants={{
              hidden: { y: "110%", opacity: 0 },
              show: {
                y: "0%",
                opacity: 1,
                transition: { duration: 0.85, ease: [0.22, 1, 0.36, 1] },
              },
            }}
            className={`inline-block ${highlight ? "brand-gradient-text" : ""}`}
          >
            {w}
          </motion.span>
        </span>
      ))}
    </motion.span>
  );
}
